module.exports = {
	common : {
		sitetitle : 'Bynn',
	},
	menu: {
		home : 'Home',
		products : 'Products',
	}
};